import React from "react";
import { WhmMenuItem, WhmTypography } from "@securitize/reactjs-whm";
import { DocumentDto } from "../../../../../data/types";
import { Translate } from "../../../../shared/translation";
import { translationKeys } from "../../../../../contexts/I18nContext";
import { useDownload } from "../useDownload";

interface DownloadMenuItemProps {
  document: DocumentDto;
}
export const DownloadMenuItem: React.FC<DownloadMenuItemProps> = ({
  document,
}) => {
  const { download, downloading } = useDownload(document);

  return (
    <WhmMenuItem disabled={downloading} onClick={() => download(document)}>
      <i
        className={`wh-icon-download`}
        style={{ paddingRight: "8px", fontSize: "20px", color: "#6c6c6c" }}
      />
      <WhmTypography variant="body1">
        <Translate
          translationKey={translationKeys.DOCUMENT_DATAGRID_MENU_DOWNLOAD_LABEL}
        />
      </WhmTypography>
    </WhmMenuItem>
  );
};
